import script from "./addServiceView.vue?vue&type=script&setup=true&lang=ts"
export * from "./addServiceView.vue?vue&type=script&setup=true&lang=ts"

import "./addServiceView.vue?vue&type=style&index=0&id=1d1012e5&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1012e5"]])

export default __exports__